export const environment = {
  production: true,
  // apiUrl: "https://qmotors-backend-staging.azurewebsites.net/api", // live
  // apiUrl: "https://qmotors-backend-testing.azurewebsites.net/api", // testing
  //  apiUrl: "https://qmotor-backend-teststaging.azurewebsites.net/api", // staginghttps://qmotor-staging.azurewebsites.net/api
  // apiUrl: "https://hostpear.co.uk/api", // staging Anas
  apiUrl: "https://api.qmotor.com/api",
  // apiUrl: "https://qmotor-staging.azurewebsites.net/api", 

  // baseUrl: "https://qmotors.innsandbox.com/", //live 
  // baseUrl: "https://qmotors-testing.innsandbox.com/", // testing
  // baseUrl: "https://gentle-bush-02b164103.5.azurestaticapps.net/", // staging
  // baseUrl : "https://app.hostpear.co.uk/", // staging Anas
   baseUrl : "https://qmotor.com/", // live Anas
  //  baseUrl : "https://qmotors-web-staging.azurewebsites.net/",
 
  googleMapsApiKeyDev: "AIzaSyDlFtsPbzRa3NTakE2pX2t6Zmbm2Hw7JSc",

  //  payment keys
  // merchantIdentifier:'GteSmWok',
  // accessCode:'dL1zPrNCEQunJLGE9q9n',
  // requestPhrase: 'P@ssWordInnovitics1234In',

  merchantIdentifier:'YdZwbPVr',
  accessCode:'Fj4ceGMFbZWlKtzIhilf',
  requestPhrase: 'QMotor@2017@qmtIn',
  // paymentReturn: "https://qmotors-web-staging.azurewebsites.net",
   paymentReturn: "https://qmotor.com",
};

export const firebaseConfig = {
  apiKey: "AIzaSyDEUEJMDvqxcVJXGVjV3gQrJF6E8ZHQyK4",
  authDomain: "foundation-test-3492a.firebaseapp.com",
  projectId: "foundation-test-3492a",
  storageBucket: "foundation-test-3492a.appspot.com",
  messagingSenderId: "290931349806",
  appId: "1:290931349806:web:7c2ebbf9d42be0354f02bf",
  measurementId: "G-BMZTVLG8NY",
};